import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import { initializeApp } from "firebase/app";
// import * as firebase from "firebase/app"
import { initializeApp } from "firebase/app";
// import * as firebase from 'firebase';
import 'firebase/firestore';
import { getFirestore } from 'firebase/firestore/lite';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCS1Tmke7kwNde2s0Z7aJRILdnEIceXkf4",
  authDomain: "careact-23.firebaseapp.com",
  projectId: "careact-23",
  storageBucket: "careact-23.appspot.com",
  messagingSenderId: "267926650801",
  appId: "1:267926650801:web:c6e9d40d43221dc1768790",
  measurementId: "G-JTW3W1E37Q"
};
const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
ReactDOM.render(<App />, document.getElementById('root'));

export default db;
